import { render, staticRenderFns } from "./AddYCoin.vue?vue&type=template&id=6644bc29&"
import script from "./AddYCoin.vue?vue&type=script&lang=js&"
export * from "./AddYCoin.vue?vue&type=script&lang=js&"
import style0 from "./AddYCoin.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports